import React from "react";
import { Slide } from "react-reveal";
import bull from "../../assets/images/icons/bull.svg";
import eye from "../../assets/images/icons/eye.svg";

const Mission = () => {
  return (
    <Slide top>
      <div className="mission-side">
        <div className="mission-vision-section">
          <div className="mission-item">
            <img src={bull} alt="Mission" />
            <div>
              <h2>Mission</h2>
              <p>
                “To deliver exceptional construction solutions with
                professionalism, safety, and sustainability - turning clients'
                visions into reality.”
              </p>
            </div>
          </div>
          <div className="mission-item">
            <img src={eye} alt="Vision" />
            <div>
              <h2>Vision</h2>
              <p>
                “To be Africa's most trusted and innivative construction
                company, building lasting structures and relationships through
                integrity, quality and excellence.”
              </p>
            </div>
          </div>
        </div>
      </div>
    </Slide>
  );
};

export default Mission;
